import React, { useState, useEffect } from 'react';
import { useForm, Controller } from "react-hook-form";
import { useDispatch, useSelector } from 'react-redux';
import { Container, Row, Col, } from 'reactstrap';
import Drawer from '@material-ui/core/Drawer';
import { AsyncSearchableSelectHookForm, SearchableSelectHookForm, TextFieldHookForm } from '../../layout/HookFormInputs';
import { getPlantSelectListByType, getTaxCodeSelectList, getVendorNameByVendorSelectList } from '../../../actions/Common';
import { autoCompleteDropdown, autoCompleteDropdownPart } from '../../common/CommonFunctions';
import { MESSAGES } from '../../../config/message';
import { checkWhiteSpaces, decimalIntegerNumberLimit, excludeOnlySpecialCharacter, getCodeBySplitting, positiveAndDecimalNumber, postiveNumber, } from "../../../helper/validation";
import { VBC_VENDOR_TYPE, ZBC, searchCount } from '../../../config/constants';
import { reactLocalStorage } from 'reactjs-localstorage';
import { getPartSelectListWtihRevNo } from '../actions/Volume';
import { getAllPartBopRmList, getMaterialGroupByPart, getPurcahseOrganisationByPlant, getSAPDetailById, saveSAPDetail, updateSAPDetail } from '../actions/SAPDetail';
import Toaster from '../../common/Toaster';
import Button from '../../layout/Button';
import { getExternalIntegrationEvaluationType, getExternalIntegrationPONumber, getExternalIntegrationStorageLocation, getExternalIntegrationUserAndEmailList } from '../../costing/actions/Costing';
import { getAllReasonAPI } from '../actions/ReasonMaster';
import { useLabels } from '../../../helper/core';
import { SAP_DETAIL_KEYS } from './SAPPushDetailConstant';

function SAPPushDetail(props) {
    const { isEditFlag, id } = props
    const { vendorLabel } = useLabels()
    const [data, setData] = useState({})
    //dropdown loader 
    const [inputLoader, setInputLoader] = useState(false)
    const [VendorInputLoader, setVendorInputLoader] = useState(false)
    const [reasonOption, setReasonOption] = useState([])
    const [selectedReason, setSelectedReason] = useState(null);
    const [vendorName, setVendorName] = useState('')
    const [partName, setPartName] = useState('')
    const [partNumber, setPartNumber] = useState('')
    const [plantCode, setPlantCode] = useState('')
    const [vendorCode, setVendorCode] = useState('')
    const dispatch = useDispatch()
    const { register, handleSubmit, control, setValue, getValues, formState: { errors } } = useForm({
        mode: 'onChange',
        reValidateMode: 'onChange',

    })
    const [disabledSaveButton, setDisabledSaveButton] = useState(true)
    const plantSelectList = useSelector(state => state.comman.plantSelectList);
    const taxCodeList = useSelector(state => state.comman.taxCodeList)
    const { evaluationType, poNumberList, storageLocationList, emailList } = useSelector((state) => state?.costing)
    const VendorLoaderObj = { isLoader: VendorInputLoader }
    const plantLoaderObj = { isLoader: inputLoader }
    const { initialConfiguration } = useSelector(state => state.auth)

    useEffect(() => {
        dispatch(getPlantSelectListByType(ZBC, 'MASTER', '', () => { }))
        dispatch(getTaxCodeSelectList(() => { }))
        dispatch(getAllReasonAPI(true, (res) => {
            if (res.data.Result) {
                setReasonOption(res.data.DataList);
                setSelectedReason(res.data.DataList[0] || null);
            }
        }));
       
        if (props.SAPDetailKeys?.some(el => Object.keys(el)[0] === SAP_DETAIL_KEYS?.EVALUATION_TYPE)) {
            setDisabledSaveButton(true);
        } else if (props.SAPDetailKeys?.length > 0) {
            setDisabledSaveButton(false);
        }
        if (isEditFlag) {
            dispatch(getSAPDetailById(id, res => {
                if (res?.data?.Result) {
                    const sapData = res?.data?.Data;
                    setData(sapData);
                    let plantCode = ''
                    const matches = sapData?.Plant?.match(/\(([^)]+)\)/g);
                    if (matches && matches?.length > 0) {
                        const lastMatch = matches[matches.length - 1];
                        plantCode = lastMatch.slice(1, -1).trim();
                    }
                    getEvaluationType(plantCode, sapData?.PartNumber)
                    // Set values for each field
                    setValue(SAP_DETAIL_KEYS?.PART_NUMBER, { label: sapData?.PartNumber, value: sapData?.PartId });
                    setValue(SAP_DETAIL_KEYS?.PLANT_CODE, { label: sapData?.Plant, value: sapData?.PlantId });
                    setValue(SAP_DETAIL_KEYS?.VENDOR_CODE, { label: sapData?.Vendor, value: sapData?.VendorId });
                    setValue(SAP_DETAIL_KEYS?.MATERIAL_GROUP, sapData?.MaterialGroup);
                    setValue(SAP_DETAIL_KEYS?.PURCHASING_ORG, sapData?.PurchasingOrg);
                    setValue(SAP_DETAIL_KEYS?.VALUATION_TYPE, { label: sapData?.ValuationType, value: sapData?.ValuationType });
                    setValue(SAP_DETAIL_KEYS?.INFO_CATEGORY, sapData?.InfoCategory);
                    setValue(SAP_DETAIL_KEYS?.TAX_CODE, { label: sapData?.TaxCode, value: sapData?.TaxCode });
                    setValue(SAP_DETAIL_KEYS?.PLANNED_DEL_TIME, sapData?.PlannedDelTime);
                    setValue(SAP_DETAIL_KEYS?.PO_NUMBER, { label: sapData?.PONumber, value: sapData?.PONumber });
                    setValue(SAP_DETAIL_KEYS?.STORAGE_LOCATION, { label: sapData?.StorageLocation, value: sapData?.StorageLocation });
                    setValue(SAP_DETAIL_KEYS?.PLANNED_DELAY_TIME, sapData?.PlannedDelayTime);
                    setValue(SAP_DETAIL_KEYS?.CREATION_PROFILE, sapData?.CreationProfile);
                    setValue(SAP_DETAIL_KEYS?.FIRM_ZONE, sapData?.FirmZone);
                    setValue(SAP_DETAIL_KEYS?.TRADE_OFF_ZONE, sapData?.TradeOffZone);
                    setValue(SAP_DETAIL_KEYS?.BINDING_MRP, sapData?.BindingMRP);
                    setValue(SAP_DETAIL_KEYS?.KANBAN_INDICATOR, sapData?.KanbanIndicator);
                    setValue(SAP_DETAIL_KEYS?.COSTING_EXECUTIVE, { label: sapData?.CostingExecutive, value: sapData?.CostingExecutive });
                
                  if(sapData?.CostingExecutive!==''||sapData?.CostingExecutive!==null||sapData?.CostingExecutive!==undefined){
                        let reqData = {
                            PartNumber: sapData?.PartNumber
                        }
                        dispatch(getExternalIntegrationUserAndEmailList(reqData, res => { }))
                
                  }
                }
            }))
        }
    }, []);

    /**
    * @method renderListing
    * @description RENDER LISTING IN DROPDOWN
    */
    const renderListing = (label) => {
        const temp = [];
        if (label === SAP_DETAIL_KEYS?.PLANT_CODE) {
            plantSelectList && plantSelectList.map((item) => {
                if (item.PlantId === '0') return false
                temp.push({ label: item.PlantNameCode, value: item.PlantId, PlantName: item.PlantName, PlantCode: item.PlantCode })
                return null
            })
            return temp
        }
        else if (label === SAP_DETAIL_KEYS?.TAX_CODE) {
            taxCodeList && taxCodeList?.map((item) => {
                if (item?.TaxCodeId === '0') return false
                temp.push({ label: item.TaxCodeAndDescription, value: item.TaxCodeId, TaxCode: item.TaxCode, Description: item.Description })
                return null
            })
            return temp
        }
        else if (label === SAP_DETAIL_KEYS?.REASON) {
            // Map options for 'department'
            // Example logic...
            reasonOption && reasonOption.map(item => {
                if (item?.Value === '0') return false
                temp.push({ label: item?.Reason, value: item?.ReasonId })
            });
            return temp;
        } else if (label === SAP_DETAIL_KEYS?.VALUATION_TYPE) {
            evaluationType && evaluationType?.map(item => {
                if (item?.Value === '') return false
                temp.push({ label: item?.Text, value: item?.Value })
            });
            return temp;
        }else if(label === SAP_DETAIL_KEYS?.PO_NUMBER){
            poNumberList && poNumberList?.map(item => {
                if (item?.Value === '') return false
                temp.push({ label: item?.Text, value: item?.Value })
            }); 
            return temp
        }else if(label === SAP_DETAIL_KEYS?.STORAGE_LOCATION){
            storageLocationList && storageLocationList?.map(item => {
                if (item?.Value === '') return false
                temp.push({ label: item?.Text, value: item?.Value })
            });
            return temp
        }
        else if(label === SAP_DETAIL_KEYS?.COSTING_EXECUTIVE){
            emailList && emailList?.map(item => {
                if (item?.Value === '') return false
                temp.push({ label: item?.Text, value: item?.Value })
            });
            return temp
        }
        return []
    }

    /**
     * @method filterList
     * @description For Filtering the vendor from List on the basis of input given in vendor dropdown
    */
    const filterList = async (inputValue) => {
        if (inputValue && typeof inputValue === 'string' && inputValue.includes(' ')) {
            inputValue = inputValue.trim();
        }
        const resultInput = inputValue.slice(0, searchCount)
        if (inputValue?.length >= searchCount && vendorName !== resultInput) {
            let res
            res = await getVendorNameByVendorSelectList(VBC_VENDOR_TYPE, resultInput)
            setVendorName(resultInput)
            let vendorDataAPI = res?.data?.SelectList
            if (inputValue) {
                return autoCompleteDropdown(inputValue, vendorDataAPI, false, [], true)
            } else {
                return vendorDataAPI
            }
        }
        else {
            if (inputValue?.length < searchCount) return false
            else {
                let VendorData = reactLocalStorage?.getObject('Data')
                if (inputValue) {
                    return autoCompleteDropdown(inputValue, VendorData, false, [], false)
                } else {
                    return VendorData
                }
            }
        }
    };

    /**
     * @method partFilterList
     * @description For Filtering the part from List on the basis of input given in part dropdown
    */
    const partFilterList = async (inputValue) => {


        if (inputValue && typeof inputValue === 'string' && inputValue.includes(' ')) {
            inputValue = inputValue.trim();
        }
        const resultInput = inputValue.slice(0, searchCount)
        if (inputValue?.length >= searchCount && partName !== resultInput) {

            const res = await getAllPartBopRmList(resultInput)

            setPartName(resultInput)
            let partDataAPI = res?.data?.DataList
            if (inputValue) {
                return autoCompleteDropdownPart(inputValue, partDataAPI, false, [], true, true)
            } else {
                return partDataAPI
            }
        }
        else {

            if (inputValue?.length < searchCount) return false
            else {
                let partData = reactLocalStorage?.getObject('PartData')
                if (inputValue) {
                    return autoCompleteDropdownPart(inputValue, partData, false, [], false, true)
                } else {
                    return partData
                }
            }
        }
    };

    const extractVendorCode = (vendorCode) => {
       // Extract the value inside the last set of parentheses
       const matches = vendorCode.match(/\(([^)]+)\)/g);
       if (matches && matches.length > 0) {
           const lastMatch = matches[matches.length - 1];
           return lastMatch.slice(1, -1).trim();
       } else {
           return vendorCode;
       }
    }
    /**
     * @method onSubmit
     * @description For saving or updation
    */
    const onSubmit = (formData) => {
        const preparedData = {};

        for (const [key, value] of Object.entries(formData)) {
         
            if (typeof value === 'object' && value !== null) {
                if (key === SAP_DETAIL_KEYS?.PART_NUMBER) {
                    preparedData[key] = value.label;
                }
                else if (key === SAP_DETAIL_KEYS?.VENDOR_CODE) {
                    const vendorCode = extractVendorCode(value?.label)
                    preparedData[key] = vendorCode;
                    // // Extract the value inside the last set of parentheses
                    // const matches = value.label.match(/\(([^)]+)\)/g);
                    // if (matches && matches.length > 0) {
                    //     const lastMatch = matches[matches.length - 1];
                    //     preparedData[key] = lastMatch.slice(1, -1).trim();
                    // } else {
                    //     preparedData[key] = value.label;
                    // }
                } else if (key === SAP_DETAIL_KEYS?.PLANT_CODE) {
                    preparedData[key] = value.PlantCode;
                } else if (key === SAP_DETAIL_KEYS?.TAX_CODE) {
                    preparedData[key] = value.TaxCode;
                } else if (key === SAP_DETAIL_KEYS?.REASON) {
                    preparedData[key] = value.value;
                }
                else if (key === SAP_DETAIL_KEYS?.PO_NUMBER) {
                    preparedData[key] = value.value;
                }
                else if (key === SAP_DETAIL_KEYS?.STORAGE_LOCATION) {
                    preparedData[key] = value.value;
                }
                else if (key === SAP_DETAIL_KEYS?.COSTING_EXECUTIVE) {
                    preparedData[key] = value?.value;
                }
                else {
                    preparedData[key] = value.label || value.value;
                }
            } else {
                preparedData[key] = value;
            }
        }
        if (isEditFlag) {
            preparedData.SapPushDetailId = data.SapPushDetailId
            dispatch(updateSAPDetail(preparedData, res => {
                if (res?.data?.Result) {
                    Toaster.success('SAP Detail updated successfully.')
                    props.closeDrawer('submit')
                }
            }))
        } else {
            dispatch(saveSAPDetail(preparedData, res => {
                if (res?.data?.Result) {
                    Toaster.success('SAP Detail added successfully.')
                    props.closeDrawer('submit')
                }
            }))
        }
    }
    /**
     * @method handlePartName
     * @description Get Material group from API on change of part
    */
    const getEvaluationType = (plantCode, partNumber) => {
        if (initialConfiguration?.IsSAPCodeRequired) {
            let reqData = {
                plantCode: plantCode,
                partNumber: partNumber
            }
            dispatch(getExternalIntegrationEvaluationType(reqData, res => {
                if (res?.data?.Result) {
                    setDisabledSaveButton(false)
                } else {
                    setDisabledSaveButton(true)
                }
            }))
        }
    }
    const handlePartName = (value,key) => {
       
        setPartNumber(value.label)
        if (value.value && plantCode !== '') {
            if(key === SAP_DETAIL_KEYS?.EVALUATION_TYPE) {
            getEvaluationType(plantCode, value.label)
        }
        
    }
    if(key === SAP_DETAIL_KEYS?.PART_NUMBER) {
        let reqData = {
            PartNumber: value?.label
        }
        dispatch(getExternalIntegrationUserAndEmailList(reqData, res => { }))

    }
        // dispatch(getMaterialGroupByPart(value.value, res => {
        //     if (res?.data.Result) {
        //         setValue('MaterialGroup', res.data.Data)
        //     }
        //     else if (res.status === 204) {
        //         Toaster.warning('Material group does not exist for this part number.')
        //     }
        // }))
    }
    /**
    * @method handlePlantNameChange
    * @description Get Purchase Organisation from API on change of plant
   */
    const handleDropdownChanges = (value, key) => {
        if (key === SAP_DETAIL_KEYS?.PLANT_CODE) {
            setPlantCode(value.PlantCode)
            setValue(SAP_DETAIL_KEYS?.VALUATION_TYPE, null);
            if (value.value && partNumber !== '') {
                if (props.SAPDetailKeys?.some(el => Object.keys(el)[0] === SAP_DETAIL_KEYS?.EVALUATION_TYPE)) {
                    getEvaluationType(value?.PlantCode, partNumber)
                }
                if (props.SAPDetailKeys?.some(el => Object.keys(el)[0] === SAP_DETAIL_KEYS?.PO_NUMBER)) {
                    handlePONumberChange(value?.PlantCode, vendorCode)
                }
                if (props.SAPDetailKeys?.some(el => Object.keys(el)[0] === SAP_DETAIL_KEYS?.STORAGE_LOCATION)) {
                    handleStorageLocationChange(value?.PlantCode, vendorCode)
                }
            }
        }
        if (key === SAP_DETAIL_KEYS?.VENDOR_CODE) {
           const vendorCode = extractVendorCode(value?.label)

            setVendorCode(vendorCode)
            if (value.value && plantCode !== '') {
                if (props.SAPDetailKeys?.some(el => Object.keys(el)[0] === SAP_DETAIL_KEYS?.PO_NUMBER)) {
                handlePONumberChange(plantCode, vendorCode)
                }
            }
           }
    }

    /**
     * @method cancelHandler
     * @description For closing of drawer
    */
    const cancelHandler = () => {
        props.closeDrawer('cancel')
    }

    const handlePONumberChange = (plantCode,vendorCode) => {
        let reqData = {
            plantCode: plantCode,
            vendorCode: vendorCode,
        }
        if(plantCode && vendorCode){
            dispatch(getExternalIntegrationPONumber(reqData, res => { }))
        }
    }
    const handleStorageLocationChange = (plantCode,vendorCode) => {
        let reqData = {
            plantCode: plantCode,
        }
        dispatch(getExternalIntegrationStorageLocation(reqData, res => { }))
        
    }
    /**
    * @method render
    * @description Renders the component
    */

    return (
        <div>
            <Drawer
                anchor={props.anchor}
                open={props.isOpen}
                onClose={(e) => cancelHandler(e)}
            >
                <Container>
                    <div className={"drawer-wrapper layout-min-width-700px"}>
                        <Row className="drawer-heading">
                            <Col>
                                <div className={"header-wrapper left"}>
                                    <h3>{"Add SAP Detail"}</h3>
                                </div>
                                <div
                                    onClick={cancelHandler}
                                    className={'close-button right'}
                                ></div>
                            </Col>
                        </Row>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <Row className="pl-3">
                                {props.SAPDetailKeys?.map((el, index) => {
                                    const [key, value] = Object.entries(el)[0];
                                    if (key === SAP_DETAIL_KEYS?.PART_NUMBER || key === SAP_DETAIL_KEYS?.VENDOR_CODE) {
                                        return (
                                            <Col md="6" key={index}>
                                                <AsyncSearchableSelectHookForm
                                                    label={key === SAP_DETAIL_KEYS?.VENDOR_CODE ? `${vendorLabel} Code` : value}
                                                    name={`${key}`}
                                                    placeholder={"Select"}
                                                    Controller={Controller}
                                                    control={control}
                                                    rules={{ required: true }}
                                                    register={register}
                                                    handleChange={(e) => key === SAP_DETAIL_KEYS?.PART_NUMBER ? handlePartName(e,key) : key === SAP_DETAIL_KEYS?.VENDOR_CODE ? handleDropdownChanges(e, key) : {}}
                                                    mandatory={true}
                                                    errors={errors[key]}
                                                    // isLoading={VendorLoaderObj}
                                                    asyncOptions={key === SAP_DETAIL_KEYS?.PART_NUMBER ? partFilterList : filterList}
                                                    NoOptionMessage={MESSAGES.ASYNC_MESSAGE_FOR_DROPDOWN}
                                                    disabled={isEditFlag ? true : false}
                                                />
                                            </Col>
                                        )

                                    } else if (key === SAP_DETAIL_KEYS?.PLANT_CODE || key === SAP_DETAIL_KEYS?.TAX_CODE || key === SAP_DETAIL_KEYS?.VALUATION_TYPE || key === SAP_DETAIL_KEYS?.PO_NUMBER || key === SAP_DETAIL_KEYS?.STORAGE_LOCATION || key === SAP_DETAIL_KEYS?.COSTING_EXECUTIVE) {
                                        return (
                                            <Col md="6" key={index}>
                                                <SearchableSelectHookForm
                                                    label={value}
                                                    name={key}
                                                    placeholder={"Select"}
                                                    Controller={Controller}
                                                    control={control}
                                                    rules={{ required: (key === SAP_DETAIL_KEYS?.VALUATION_TYPE && !(evaluationType.length > 1)) ? false : true }}
                                                    register={register}
                                                    options={renderListing(key)}
                                                    mandatory={(key === SAP_DETAIL_KEYS?.VALUATION_TYPE && !(evaluationType.length > 1)) ? false : true}
                                                    handleChange={(e) => handleDropdownChanges(e, key)}
                                                    errors={errors[key]}
                                                    disabled={isEditFlag && key === SAP_DETAIL_KEYS?.PLANT_CODE ? true : false}
                                                    isLoading={plantLoaderObj}

                                                />
                                            </Col>
                                        )
                                    }
                                    else {
                                        return (
                                            <Col md="6" key={index}>
                                                <TextFieldHookForm
                                                    label={value}
                                                    name={key}
                                                    Controller={Controller}
                                                    control={control}
                                                    register={register}
                                                    mandatory={true}
                                                    rules={{
                                                        required: true,
                                                        validate: key === SAP_DETAIL_KEYS?.CREATION_PROFILE || key === SAP_DETAIL_KEYS?.FIRM_ZONE || key === SAP_DETAIL_KEYS?.TRADE_OFF_ZONE ? { checkWhiteSpaces, postiveNumber } : key === SAP_DETAIL_KEYS?.BINDING_MRP  ? { checkWhiteSpaces, positiveAndDecimalNumber } : key === SAP_DETAIL_KEYS?.KANBAN_INDICATOR ? { checkWhiteSpaces, excludeOnlySpecialCharacter } :  {checkWhiteSpaces},
                                                    }}
                                                    handleChange={(e) => { }}
                                                    className=""
                                                    customClassName={'withBorder scrap-recovery'}
                                                    errors={errors[key]}
                                                    disabled={false}    
                                                />
                                            </Col>
                                        )
                                    }
                                })}

                            </Row>

                            <Row className="justify-content-between">
                                <div className="col-sm-12 text-right">
                                    <Button
                                        id="addSAPDetail_cancel"
                                        className="mr-2 mt-0"
                                        variant={"cancel-btn"}

                                        onClick={cancelHandler}
                                        icon={"cancel-icon"}
                                        buttonName={"Cancel"}
                                    />
                                    <Button
                                        id="addSAPDetail_updateSave"
                                        type="submit"
                                        className="mr5"

                                        icon={"save-icon"}
                                        disabled={disabledSaveButton}
                                        buttonName={isEditFlag ? "Update" : "Save"}
                                    />
                                </div>
                            </Row>
                        </form>
                    </div>
                </Container>
            </Drawer>
        </div>
    );
}

export default React.memo(SAPPushDetail)
